import type {
  ManagedTemplateQuestionnaireResponse,
  QuestionnaireResponse,
  QuestionnaireResultResponse
} from '@gcv/shared';
import { BankTemplateCategory, BO_V2_QUESTIONNAIRE_FIELD_SCHEMA } from '@gcv/shared';

//We only show when in edit mode and for v2 Bo questionnaires
export const shouldDisplayBosAsObj = (
  templateResponse: QuestionnaireResponse | ManagedTemplateQuestionnaireResponse | undefined,
  templateResultResponse: QuestionnaireResultResponse | undefined,
  editMode: boolean
): boolean => {
  if (editMode === false) return false;

  if (!templateResponse) return false;

  if (!templateResultResponse) return false;

  if (templateResultResponse.template_category !== BankTemplateCategory.BeneficialOwnership) return false;

  const boVersion = Object.keys(templateResponse.custom_requirements).includes(
    BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_1.id
  )
    ? 'v2'
    : 'v1';

  if (boVersion !== 'v2') return false;

  const requirement =
    templateResponse.custom_requirements?.[BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_1.id];

  if (!requirement || requirement.archived) return false;

  const beneficialOwnerRequirementResults = templateResultResponse.custom_requirement_result.filter(
    (requirementResult) =>
      requirementResult.requirement_id === BO_V2_QUESTIONNAIRE_FIELD_SCHEMA.beneficial_ownership_v2_1.id
  );

  const hasLegacyBeneficialOwnerResponses = beneficialOwnerRequirementResults.some(
    (requirementResult) =>
      !requirementResult.managed_id &&
      Object.values(requirementResult.custom_fields.responses ?? {}).some((response) => {
        if (response == null) return false;
        if (typeof response === 'string') return !!response.trim();
        if (Array.isArray(response)) return !!response.length;
        return true;
      })
  );

  return !hasLegacyBeneficialOwnerResponses;
};
